import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Alert } from 'reactstrap';

import * as vars from '../../constants/variables';

import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getCountries, getLanguages, getCountryDomainAndSubDomain, openCountryDetail } from "../../actions/CountryActions";

import { console_log, jsUcfirst, formatDate } from "../../utils/helper";
import { FormattedMessage } from 'react-intl';

class AddCountryLanguage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            country: 0,
            languages: [],
            subDomain: '',
            domainIds: [],
            domainId: 0,
            domain: '',
            url: '',
            isValid: false,
            errorMessage: ''
        };

        this.onChange = this.onChange.bind(this);
        this.cancel = this.cancel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    componentWillMount() {
        this.getCountries();
        this.getLanguages();

        this.setState({
            country: this.props.country.countryManagement.countryId,
            languages: this.props.country.countryManagement.language.map(l => l.languageId),
            domainIds: this.props.country.countryManagement.domain.map(d => d.domainId)
        });
    }

    componentDidUpdate() {
        if (!this.props.user.isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    getCountries() {
        axios.get(vars.BASE_URL+'/getCountries')
            .then((response) => {
                if (response.data.success) {
                    this.props.getCountries(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
            })
    }

    getLanguages() {
        axios.get(vars.BASE_URL+'/getLanguages')
            .then((response) => {
                if (response.data.success) {
                    this.props.getLanguages(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
            })
    }

    onChange(e) {
        if (e.target.name == 'subdomainname') {
            let url = (this.state.domain != '') ? this.state.domain.split('_')[1] : '';
            this.setState({
                subDomain: e.target.value,
                url: e.target.value + '.' + url
            })
        } else {
            if (e.target.value != 0) {
                this.setState({
                    domain: e.target.value,
                    domainId: e.target.value.split('_')[0],
                    url: this.state.subDomain + '.' + e.target.value.split('_')[1]
                })
            }
        }
    }

    cancel() {
        this.props.history.goBack();
    }

    isValid() {
        if (this.state.subDomain === '') {
            this.setState({
                isValid: false,
                errorMessage: "Subdomain cannot be blank"
            });
            return false;
        }

        if (this.state.domainId === 0) {
            this.setState({
                isValid: false,
                errorMessage: "Please select a domain to map subdomain."
            });
            return false;
        }

        return true;
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.isValid()){
            this.setState({ isValid: true, errorMessage: ''});
            this.addSubdomain({
                domainId: this.state.domainId,
                subDomainName: this.state.subDomain
            });
        }
    }

    addSubdomain(data) {
        this.props.show();
        axios.post(vars.BASE_URL+'/addSubDomain', data)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.props.history.goBack();
                    this.setState({
                        domainId: 0,
                        isValid: false,
                        errorMessage: ''
                    })
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to post data.'});
            })
    }

    render() {
        console_log("Props", this.props);
        return (
            <div className="addcountrylanguage animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Edit Country</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="countryname">Country Name</Label>
                                            <Input type="select" id="countryname" name="countryname" value={this.state.country} placeholder="Country Name" disabled>
                                                {this.props.country.countries.length > 0 ?
                                                    this.props.country.countries.map((c, k) => {
                                                        return (
                                                            <option key={c.countryId} value={c.countryId}>{c.name}</option>
                                                        )
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="language">Language</Label>
                                            <Input type="select" name="language" id="language" value={this.state.languages} multiple disabled>
                                                {this.props.country.languages.length > 0 ?
                                                    this.props.country.languages.map((l, k) => {
                                                        return (
                                                            <option key={l.languageId} value={l.languageId}>{l.englishName}</option>
                                                        )
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                        {/*<Col xs="12" md="4">*/}
                                            {/*<Label htmlFor="mainlanguage">Main Language</Label>*/}
                                            {/*<Input type="select" id="mainlanguage" name="mainlanguage">*/}
                                                {/*<option value="0">English</option>*/}
                                                {/*<option value="1">Hindi</option>*/}
                                                {/*<option value="2">Malayalam</option>*/}
                                            {/*</Input>*/}
                                        {/*</Col>*/}
                                    </FormGroup>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add Sub Domain and Details</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="subdomainname">Sub Domain Name</Label>
                                            <Input type="text" id="subdomainname" name="subdomainname" value={this.state.subDomain} onChange={this.onChange} placeholder="Sub Domain Name" />
                                        </Col>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="selectdomain">Domain URL</Label>
                                            <Input type="select" name="selectdomain" id="selectdomain" value={this.state.domain} onChange={this.onChange}>
                                                <option key={0} value={0}>Select Domain</option>
                                                {this.props.country.countryManagement.domain.length > 0 ?
                                                    this.props.country.countryManagement.domain.map((d) => {
                                                        let url = d.domainUrl.split('//')[1];
                                                        return (
                                                            <option key={d.domainId} value={d.domainId + '_' + url}>{d.domainUrl}</option>
                                                        )
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                        <Col xs="12" md="4">
                                            <Label htmlFor="url">URL</Label>
                                            <Input type="text" id="url" name="url" value={this.state.url} disabled/>
                                        </Col>
                                    </FormGroup>
                                    {(!this.state.isValid && this.state.errorMessage != '') ?
                                        <Alert color="danger">{this.state.errorMessage}</Alert> : ''}
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary" onClick={this.cancel}><i className="fa fa-times"></i>
                                    <FormattedMessage id="cancel"
                                        defaultMessage=" Cancel"
                                    />
                                </Button>{' '}
                                <Button type="submit" color="success" onClick={this.onSubmit}><i className="fa fa-check"></i>
                                    <FormattedMessage id="save"
                                        defaultMessage=" Save"
                                    />
                                 </Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getCountries,
        getLanguages
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCountryLanguage);


// WEBPACK FOOTER //
// ./src/components/Country/AddCountryLanguage.js